// extracted by mini-css-extract-plugin
export default {"optionBlock":"oVeWhBTW5N_cpsjjqB8e","deactivated":"_70e3Rl1K1SYRFqy9w4r"};